/**
 * Route setting
 */

export const redesignV2BasePath = '/redesign';

export const redesignV2RoutePath = {
  HOME: redesignV2BasePath,
  PRICING: `${redesignV2BasePath}/pricing`,
  PRICING_DETAIL: `${redesignV2BasePath}/pricing/detail`,
  SHOP: `${redesignV2BasePath}/shop`,
  PURCHASE: `/purchase`,
  CART: `/cart`,
};
